// extracted by mini-css-extract-plugin
export var readonly = "_h9-1";
export var star = "_h9-0";